export default "__VITE_ASSET__BAr61_6a__"